import React from 'react';

import {NotesSection} from 'src/components/notes-section';
import {useAdminAccessRight} from 'src/hooks/access-rights';
import {useEventTracking} from 'src/hooks/useEventTracking';

import {useUserNotes} from './useUserNotes';

type Props = {
    userId: number,
};

export const UserNotesSection: React.FC<Props> = ({userId}) => {
    const {
        isLoading: isUserNotesLoading,
        loadingError: userNotesLoadingError,
        isChanged: isUserNotesChanged,

        data: userNotes,
        setData: setUserNotes,

        saveChanges: saveUserNotes,
        discardChanges: discardUserNotes,
    } = useUserNotes({userId});

    const {userFieldChange, userSubmit} = useEventTracking();
    const {canEditUserNotes} = useAdminAccessRight();

    return (
        <NotesSection
            headline="User Notes"
            isLoading={isUserNotesLoading}
            loadingError={userNotesLoadingError}
            isNotesChanged={isUserNotesChanged}

            canEdit={canEditUserNotes()}
            notes={userNotes.value || ''}
            chunk="user-notes"

            onChange={data => {
                userFieldChange({
                    section: 'Notes', parameterName: 'notes', viewType: 'Existed',
                });
                return setUserNotes(data);
            }}
            onSave={() => {
                userSubmit({place: 'User Notes', submit: true});
                return saveUserNotes();
            }}
            onDiscard={() => {
                userSubmit({place: 'User Notes', submit: false});
                discardUserNotes();
            }}
        />
    );
};
